<template>
    <v-container>
        <v-row>
            <v-col lg="12">
                <history-record @rowSelected="rowSelected($event)"></history-record>
            </v-col>
            <v-col class="pt-0" lg="12">
                <history-list
                    v-show="person"
                    :WorkerName="person ? person.NtpFullName : ''"
                    :PrsDocumentNumber="person ? person.PrsDocumentNumber : ''"
                    :person="person"
                    :key="person ? person.PrsDocumentNumber : 'empty'"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import HistoryRecord from './HistoryRecord.vue';
import HistoryList from './HistoryList.vue';

export default {
    components: {
        HistoryRecord,
        HistoryList
    },
    data() {
        return {
            person: null
        };
    },
    methods: {
        rowSelected(rows) {
            if (rows.length > 0) {
                this.person = rows[0];
            }
        }
    }
};
</script>
